var $ = require( 'jquery' );

import select2 from 'select2';
import 'slick-carousel';
import magnificPopup from 'magnific-popup';

$( document ).ready( function() {
    initSelect2();

    if ($(window).width() >= 768) {
    }
    handleTeamFilters();

   handlePopup();
});

function handleTeamFilters() {
    var categoryFilters = $('.team-list__category'),
        activeCategory  = $('.team-list__category.active').attr('data-category'),
        teamMember      = $('.team-list__member'),
        membersWrap     = $('.team-list__members');

    setTimeout(function() {
        $('.team-list__members-wrapper').css('min-height', membersWrap.outerHeight());
    }, 300)
    
    teamMember.each(function() {
        var memberCategory = $(this).attr('data-category');

        if (memberCategory.indexOf(activeCategory) >= 0 ) {
            var that = $(this);

            $(this).removeClass('hidden');

            setTimeout(function() {
                that.addClass('active');
            }, 300)
        }
    })

    categoryFilters.on('click', function() {
        if (!$(this).hasClass('active')) {
            categoryFilters.removeClass('active');
            $(this).addClass('active');

            teamMember.removeClass('active');

            setTimeout(function() {
                teamMember.addClass('hidden');
            }, 200)

            setTimeout(function() {
                var currentHeight = membersWrap.outerHeight();
                
                $('.team-list__members-wrapper').css('min-height', currentHeight);
            }, 500)

            setTimeout(function() {
                var activeCat  = $('.team-list__category.active').attr('data-category');

                teamMember.each(function() {
                    var memberCategory = $(this).attr('data-category');

                    if (memberCategory.indexOf(activeCat) >= 0) {
                        var that = $(this);
                        $(this).removeClass('hidden');
                        setTimeout(function() {
                            that.addClass('active');
                        }, 100)
                    }
                })
            }, 400);
        }
    });
}

function initSelect2() {
    var selectElement   = $('.team-list__categories-select'),
        slidersWrapper  = $('.team-list__members-sliders-wrapped'),
        currentHeight   = $('.team-list__member:visible').outerHeight();


    selectElement.each( function() {
		var $element = $(this),
			$elementName = $element.attr('name'),
			$placeholder = ' ';

        $element.select2({ 
            placeholder: $placeholder,
            maximumSelectionLength: -1,
			minimumResultsForSearch: -1,
			width: '100%'
        });
    });

    var currentSelect = selectElement.find(':selected').attr('data-category');
    slidersWrapper.addClass('hidden');

    $('.team-list__members-sliders-wrapped[data-slider-category="'+currentSelect+'"]').removeClass('hidden').addClass('active');

    setTimeout(() => { slidersWrapper.css('min-height', currentHeight); }, 100);
    
    selectElement.on('select2:select', function (e) {
        var selectedElement = $(this).find(':selected').attr('data-category');
        slidersWrapper.removeClass('active');
            
        setTimeout(function() {
            slidersWrapper.addClass('hidden');
        }, 400);

        setTimeout(function() {
            var activeCat  = $('.team-list__category.active').attr('data-category');

            $('.team-list__members-sliders-wrapped[data-slider-category="'+selectedElement+'"]').removeClass('hidden');

            setTimeout(function() {
                $('.team-list__members-sliders-wrapped[data-slider-category="'+selectedElement+'"]').addClass('active');
            }, 100)
            
            slidersWrapper.slick('slickGoTo', 0);
            slidersWrapper.slick('refresh');
 
        }, 400);
    });

    var slideshowContainer = $( ".team-list__members-sliders-wrapped" );

    slideshowContainer.not('.slick-initialized').slick({
        rows: 0,
        dots: true,
        arrows: false,
        lazyLoad: 'ondemand',
        infinite: true,
        autoplay: true,
        autoplaySpeed: 3000,
        slidesToShow: 1,
        slidesToScroll: 1,
        pauseOnHover: true,
        pauseOnFocus: false,
        swipeToSlide: true,
    });
}

function handlePopup() {
	var popupElem 		= $('.team-list__member-wrapped'),
		scrollbarWidth 	= window.innerWidth - $(window).width(),
        windowWidth 	= scrollbarWidth + $(window).width();
    var popupCloseTrigger = $('.team-list__member-popup-close-wrap');

        
    popupElem.on('click', function (e) {

        var triggetData = $(this).find('.team-list__member-popup');

        // var popupElem = $(`.speaker__popup[speaker-data-id='${triggetData}']:first`);

        $.magnificPopup.open({
            items: {
                src: triggetData,
                type: 'inline'
            },
            callbacks: {
                open: function() {                        // When you open the
                    // $('html, body').css({'overflow': 'hidden', 'width': windowWidth });  // window, the element
                    // $('.mfp-wrap').css({'overflow': 'visible'});
                    $('.site-header:visible').css({'padding-right': scrollbarWidth, 'transition': 'unset' })
                },                                        // "body" is used "overflow: hidden".
    
                close: function() {                       // When the window
                    $('.site-header:visible').css("padding-right", "");

                    setTimeout(function() {
                        $('.site-header:visible').removeAttr("style");

                    }, 200)

                    //$('html, body').css({'overflow': '', 'width': ''});        // is closed, the
                },                                        // "overflow" gets the initial value.
    
            },
            mainClass: 'mfp-fade',
            removalDelay: 300,
            closeOnBgClick: true,
            fixedBgPos: true,
            showCloseBtn: false,
            verticalFit: false,
            fixedContentPos: true,
            autoFocusLast: false
        });
    });


    popupCloseTrigger.on('click', function() {
        $.magnificPopup.close();
    })
    

}